<template>
  <div>
    <vx-card style="margin-bottom: 15px">
      <b-row align-v="center">
        <b-col lg="2" sm="5">
          <b-form-input
            v-model="bakiye1"
            @keyup.enter="getCaririskRapor"
            id="smallInput"
            placeholder="Bakiye 1"
          />
        </b-col>
        <b-col lg="2" sm="5">
          <b-form-input
            v-model="bakiye2"
            @keyup.enter="getCaririskRapor"
            id="smallInput"
            placeholder="Bakiye 2"
          />
        </b-col>
        <b-col lg="3" sm="5">
          <v-select
            v-model="siralama"
            :options="siralamaList"
            class="select-size-sm"
            label="name"
            placeholder="Sıralama"
            style=""
            @input="getCaririskRapor"
          >
          </v-select>
        </b-col>
        <b-col lg="2" sm="5">
          <vs-checkbox v-model="checkBox1">Risksizler Çıkmasın</vs-checkbox>
        </b-col>
        <b-col lg="2" sm="2">
          <vs-button
            style="border-radius: 5px; width: 100%"
            type="gradient"
            size=""
            @click="getCaririskRapor()"
            id="button-with-loading-yeni"
            class="vs-con-loading__container"
            >Listele</vs-button
          >
        </b-col>
        <b-col lg="2" sm="5">
          <b-form-input
            v-model="cariNo1"
            @keyup.enter="getCaririskRapor"
            id="smallInput"
            placeholder="Cari No 1"
          />
        </b-col>
        <b-col lg="2" sm="5">
          <b-form-input
            v-model="cariNo2"
            @keyup.enter="getCaririskRapor"
            id="smallInput"
            placeholder="Cari No 2"
          />
        </b-col>

        <b-col lg="3" sm="5">
          <b-form-input
            v-model="cariAdi"
            @keyup.enter="getCaririskRapor"
            id="smallInput"
            placeholder="Cari Adı"
          />
        </b-col>
      </b-row>
    </vx-card>

    
    <vx-card>
      <ag-grid-vue
        style="width: 100%; height: 450px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :rowData="rowData"
        :localeText="localeText"
        :pagination="true"
        @grid-ready="onGridReady"
        @first-data-rendered="onFirstDataRendered"
      >
      </ag-grid-vue>
    </vx-card>
  </div>
</template>
<script>
import Store from "../../store/store";
import state from "../../store/state";
import vSelect from "vue-select";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import caririskRaporuBakiyeRenderer from "./CellRenderers/caririskRaporuBakiyeRenderer.vue";
import caririskRaporuCekRenderer from "./CellRenderers/caririskRaporuCekRenderer.vue";
import caririskRaporuGecikenCekRenderer from "./CellRenderers/caririskRaporuGecikenCekRenderer.vue";
import caririskRaporuSenetRenderer from "./CellRenderers/caririskRaporuSenetRenderer.vue";
import caririskRaporuGecikenSenetRenderer from "./CellRenderers/caririskRaporuGecikenSenetRenderer.vue";
import caririskRaporuOrtvadeRenderer from "./CellRenderers/caririskRaporuOrtvadeRenderer.vue";
import caririskRaporuAlcvadeRenderer from "./CellRenderers/caririskRaporuAlcvadeRenderer.vue";
import CariRiskDetayButon from "../components/crm-components/finans-components/CariRiskDetayButon.vue";

export default {
  data() {
    return {
      localeText: null,
      rowData: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      bakiye2: "",
      bakiye1: "",
      cariNo1: "",
      cariNo2: "",
      checkBox1: false,
      cariAdi: "",
      siralama: "",
      siralamaList: [
        {
          name: "Müşteri Adı A-Z",
          val: "CARIKART_CARIADI",
        },
        { name: "Müşteri Adı Z-A", val: "CARIKART_CARIADI DESC" },
        { name: "Risk A-Z", val: "TOPLAMPUAN" },
        { name: "Risk Z-A", val: "TOPLAMPUAN DESC" },
        { name: "Bakiye A-Z", val: "CARIKART_BAKIYE" },
        { name: "Bakiye Z-A", val: "CARIKART_BAKIYE DESC" },
      ],
    };
  },
  components: {
    AgGridVue,
    "v-select": vSelect,
    caririskRaporuBakiyeRenderer,
    caririskRaporuCekRenderer,
    caririskRaporuGecikenCekRenderer,
    caririskRaporuSenetRenderer,
    caririskRaporuGecikenSenetRenderer,
    caririskRaporuOrtvadeRenderer,
    caririskRaporuAlcvadeRenderer,
    CariRiskDetayButon
  },
  methods: {
    currencyFormatter(currency) {
      var parfloat = parseFloat(currency);

      if (typeof currency == "undefined" || currency == null) return "";
      else {
        var sansDec = parfloat.toFixed(2);
        var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return "₺" + `${formatted}`;
      }
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    getCaririskRapor() {
      var vm = this;
      var vs = this.$vs;
      vs.loading({
        background: "#0064fa",
        color: "#fff",
        container: "#button-with-loading-yeni",
        scale: 0.45,
      });
      console.log(vm.siralama);
      var siralamadeger = vm.siralama.val;
      if (vm.siralama == "") siralamadeger = "CARIKART_CARIADI";
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        cari1: vm.cariNo1,
        cari2: vm.cariNo2,
        bakiye1: vm.bakiye1,
        bakiye2: vm.bakiye2,
        sorguRisk: vm.checkBox1,
        siralama: siralamadeger,
        CariAd: vm.cariAdi,
      };
      console.log(args);

      soap.createClient(url, function (err, client) {
        client.INT_CariRisk(args, function (err, result) {
          if (result.INT_CariRiskResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_CariRiskResult);
            if (vm.veriler.response == "Ok") {
              vm.rowData = JSON.parse(vm.veriler.jsonData);
              console.log(vm.rowData);
              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            } else {
              vs.notify({
                title: "Hata",
                text: "Liste getirilirken hata oluştu" + vm.veriler.error,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          } catch (error) {
            console.log(error);
            vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            vs.notify({
              title: "Hata",
              text: "Liste getirilirken hata oluştu",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        });
      });
    },
  },
  created() {
    //  this.getCaririskRapor();
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
  },
  beforeMount() {
    this.columnDefs = [
      {
        width: 100,
        field: "",
        cellRendererFramework: "CariRiskDetayButon",
      },
      {
        headerName: "Firma / Müşteri",
        field: "CARIADI",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Bakiye",
        field: "CARIKART_BAKIYE",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "caririskRaporuBakiyeRenderer",
        type: "rightAligned",
        wrapText: true,
        autoHeight: true,
      },

      {
        headerName: "Çek",
        field: "CEKTOPLAM",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "caririskRaporuCekRenderer",
        type: "rightAligned",
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "Geciken Çek",
        field: "GECIKENCEKTOPLAM",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "caririskRaporuGecikenCekRenderer",
        type: "rightAligned",
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "Senet",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "caririskRaporuSenetRenderer",
        type: "rightAligned",
        field: "SENETTOPLAM",
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "Geciken Senet",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        field: "GECIKENSENETTOPLAM",
        cellRenderer: "caririskRaporuGecikenSenetRenderer",
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "Genel Puan",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellStyle: { color: "#7367f0", "font-size": "20px" },
        valueFormatter: (params) =>
          this.currencyFormatter(params.data.TOPLAMPUAN),
        type: "rightAligned",
        field: "TOPLAMPUAN",
      },
      {
        headerName: "Borç Ort. Vade",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        field: "BORCORT",
        cellRenderer: "caririskRaporuOrtvadeRenderer",
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "Alc Ort. Vade",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "caririskRaporuAlcvadeRenderer",
        type: "rightAligned",
        field: "ALCAKORT",
        wrapText: true,
        autoHeight: true,
      },
    ];
  },
};
</script>